import React from 'react';
import './AuthCallbackPage.css';

const AuthCallbackPage: React.FC = () => {
  return (
    <div className="auth-callback-container">
      <div className="auth-callback-card">
        <h1>Loggar in...</h1>
        <p>Vänta medan vi loggar in dig...</p>
        <div className="loading-spinner"></div>
      </div>
    </div>
  );
};

export default AuthCallbackPage;














